export default "__VITE_ASSET__07f5854c__"